// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","native":"Button_native__ULVbz","secondary":"Button_secondary__sUGsj"};